/**
 * Find value by id property
 */
export function findById(values, id) {
    return values.find(v => v.id === id);
}
//# sourceMappingURL=dash.js.map